// @flow

import React, { type Node, useEffect } from 'react';

import { useIncomingPayment, getSafeAllowedPaymentTypes } from '@tectonics/prs/incoming-payment';
import { type LookAndFeelRootPropsOpenedPayment } from '@tectonics/look-and-feel';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { ContextProvider } from './context-provider';
import { PageTemplate } from '../../commons/templates';
import { Form } from './form';
import { Empty } from '../../commons/atoms';

export function OpenedPaymentPage(props: LookAndFeelRootPropsOpenedPayment): Node {
  return (
    <ContextProvider {...props}>
      <PageTemplate data-test-id="page-opened-payment">
        <SetInitialSelectedPaymentMethod />
        <Form onSubmit={props.onSubmit} />
      </PageTemplate>
    </ContextProvider>
  );
}

function SetInitialSelectedPaymentMethod(): Node {
  const [,setSelectedPaymentMethod] = useUserInputValue('selectedPaymentMethod');
  const incomingPayment = useIncomingPayment();
  if (incomingPayment.status !== 'OP') {
    throw new Error(`Opened Payment: Payment status should be OP. Currently is ${incomingPayment.status}`);
  }
  const allowedPaymentTypes = getSafeAllowedPaymentTypes(incomingPayment);

  useEffect(() => {
    if (allowedPaymentTypes.length !== 1) {
      throw new Error(`Opened Payment: there should be only one allowed payment type. Currently the available payment options are:\n${JSON.stringify(allowedPaymentTypes, null, 2)}`);
    }
    setSelectedPaymentMethod(allowedPaymentTypes[0]);
  }, [setSelectedPaymentMethod, allowedPaymentTypes]);

  return <Empty />;
}
